// eslint-disable-next-line no-unused-vars
import { FaCoins, FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTokenBalance } from '../hooks/useTokenBalance';
import { formatSHPrice } from '../utils/priceFormatter.js';

const TokenDisplay = () => {
  const navigate = useNavigate();
  const { shinketsuAmount, loading, miningEffect } = useTokenBalance();

  // ユーザーの権限レベルをJWTトークンから取得（信頼できる情報源）
  const getPermissionFromToken = () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return 1;
      const parts = token.split('.');
      if (parts.length === 3) {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const tokenData = JSON.parse(jsonPayload);
        return tokenData.permission_level || 1;
      }
    } catch {
      return 1;
    }
    return 1;
  };

  const userPermissionLevel = getPermissionFromToken();
  const isSemiMember = userPermissionLevel === 2;

  if (loading) {
    return (
      <div className="flex items-center space-x-1 text-white/80">
        <FaCoins size={14} />
        <span className="text-xs">...</span>
      </div>
    );
  }

  return (
    <div
      className="relative flex items-center space-x-1 text-white cursor-pointer hover:opacity-80 transition-opacity"
      onClick={() => navigate('/wallet')}
      title="ウォレットを開く"
    >
      <FaCoins size={14} className="text-yellow-400" />
      <span
        className="text-xs font-semibold flex items-center space-x-1"
        title={`${shinketsuAmount} SH - クリックでウォレットを開く`}
      >
        <span>{formatSHPrice(shinketsuAmount)}</span>
        {/* 準会員には鍵付きマークを表示 */}
        {isSemiMember && (
          <FaLock
            size={10}
            className="text-yellow-300 opacity-80"
            title="本会員昇格でウォレット機能が解放されます"
          />
        )}
      </span>

      {/* マイニング/消費エフェクト */}
      {miningEffect && (
        <div
          className="absolute -top-12 left-1/2 -translate-x-1/2 pointer-events-auto whitespace-nowrap"
          style={{ zIndex: 9999 }}
        >
          <div
            className={`animate-bounce-up-fade font-bold text-base drop-shadow-2xl ${
              miningEffect.isConsumption ? 'text-red-500' : 'text-green-400'
            }`}
            style={{
              filter: 'drop-shadow(0 0 8px rgba(0,0,0,0.8))',
              textShadow: '0 0 10px rgba(0,0,0,0.8)',
            }}
          >
            <div className="flex items-center space-x-1 bg-black/50 px-3 py-1 rounded-full relative">
              {/* 操作別アイコン */}
              {(miningEffect.icon || miningEffect.source) && (
                <span className="text-xl animate-pulse">
                  {miningEffect.icon || 
                    (miningEffect.source === 'freeze' ? '🧊' : 
                     miningEffect.source === 'stake' ? '🔒' : 
                     miningEffect.source === 'purchase' ? '🛒' : 
                     miningEffect.isConsumption ? '💸' : '✨')}
                </span>
              )}
              <span className="font-extrabold">{miningEffect.display} SH</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TokenDisplay;
